<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 保险订单管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>

            <div class='handle-box'>


                <el-select v-model='query.type' placeholder='请选择支付方式' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in typeOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-select v-model='query.status' placeholder='请选择订单状态' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in statusOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-input v-model='query.heHuoName' placeholder='合伙人姓名' class='handle-input mr10'
                          style='width: 160px'></el-input>
                <el-input v-model='query.tbrName' placeholder='投保人姓名' class='handle-input mr10'
                          style='width: 160px'></el-input>
                <el-input v-model='query.bbrName' placeholder='被保人姓名' class='handle-input mr10'
                          style='width: 160px'></el-input>
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>导出</el-button>

            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label='保险号' align='center' width='170px'>
                    <template slot-scope='scope'>{{ scope.row.tradeNo }}</template>
                </el-table-column>

                <el-table-column label='企业名称' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.excelEnterpriseName }}</template>
                </el-table-column>
                <el-table-column label='投保预算金额' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.excelAmount }}</template>
                </el-table-column>
                <el-table-column label='被保人姓名' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.bbrName }}</template>
                </el-table-column>
                <el-table-column label='保险类型' align='center' width='100px'>
                    <template slot-scope='scope'>{{ scope.row.insuranceProductsPo.name }}</template>
                </el-table-column>
                <el-table-column label='发票抬头' align='center' width='100px'>
                    <template slot-scope='scope'>{{ scope.row.excelTitleInvoiceName }}</template>
                </el-table-column>
                <el-table-column label='发票抬头类型' align='center' width='100px'>
                    <template slot-scope='scope'>{{ scope.row.excelTitleInvoiceType }}</template>
                </el-table-column>


                <el-table-column label='付款类型' align='center' width='80rpx'>
                    <template slot-scope='scope'>{{ scope.row.type==0?"线下":"线上" }}</template>
                </el-table-column>

                                <el-table-column label='当前状态' align='center' width='80rpx'>
                                    <template slot-scope='scope'>{{ scope.row.statusName}}</template>
                                </el-table-column>

                <el-table-column label='创建时间' align='center' width='170px'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>
                </el-table-column>

                <el-table-column label='操作'  align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            v-if='scope.row.status==4'
                            @click='checkOrder(scope.$index, scope.row)'
                        >审核
                        </el-button>

                        <el-button
                            type='text'
                            class='blue'
                            v-if='scope.row.status==2'
                            @click='fanXian(scope.$index, scope.row)'
                        >返现
                        </el-button>
                        <el-button
                            type='text'
                            @click='watchOrder(scope.$index, scope.row)'
                        >查看详情
                        </el-button>
                        <el-button
                            type='text'
                            @click='watchPdf(scope.$index, scope.row)'
                        >融资pdf下载
                        </el-button>
                        <el-button
                            type='text'
                            @click='excelTax(scope.$index, scope.row)'
                        >开票信息导出
                        </el-button>

                        <!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-delete'-->
<!--                            class='red'-->
<!--                            @click='handleDelete(scope.$index, scope.row)'-->
<!--                        >删除-->
<!--                        </el-button>-->

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <el-dialog title='审批' :visible.sync='checkVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='保单号'>
                    <el-input v-model='createForm.tradeNo' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险名'>
                    <el-input v-model='createForm.baoXieName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price/100' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='企业名称'>
                    <el-input v-model='createForm.excelEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票抬头'>
                    <el-input v-model='createForm.excelTitleInvoiceName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='抬头类型'>
                    <el-input v-model='createForm.excelTitleInvoiceType' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票税号'>
                    <el-input v-model='createForm.excelTaxId' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票金额'>
                    <el-input v-model='createForm.excelTaxAmount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票email'>
                    <el-input v-model='createForm.excelTaxEmail' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票备注'>
                    <el-input v-model='createForm.excelTaxRemark' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票地址'>
                    <el-input v-model='createForm.excelTaxAddress' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票电话'>
                    <el-input v-model='createForm.excelTaxPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行名称'>
                    <el-input v-model='createForm.excelTaxBank' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行账号'>
                    <el-input v-model='createForm.excelTaxBankAccount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='身份证正面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelFrontIdCardUrl"
                        :preview-src-list="[createForm.excelFrontIdCardUrl]">
                    </el-image>

                </el-form-item>
                <el-form-item label='身份证反面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelBackIdCardUrl"
                        :preview-src-list="[createForm.excelBackIdCardUrl]">
                    </el-image>

                </el-form-item>



                <el-form-item label='营业执照'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelYyzz"
                        :preview-src-list="createForm.bbrZlhtUrls">
                    </el-image>

                </el-form-item>

                <el-form-item label='付款凭证'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.fkpzUrl"
                        :preview-src-list="createForm.fkpzUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='开票照片'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.ticketPhoto"
                        :preview-src-list="[createForm.ticketPhoto]">
                    </el-image>

                </el-form-item>


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='checkVisible = false'>取 消</el-button>
                 <el-button type='danger' @click='updateStatus(10)'>驳 回</el-button>
                <el-button type='primary' @click='updateStatus(2)'>审 核</el-button>
            </span>
        </el-dialog>
        <el-dialog title='返现' :visible.sync='cashbackVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='保单号'>
                    <el-input v-model='createForm.tradeNo' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险名'>
                    <el-input v-model='createForm.baoXieName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price/100' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='企业名称'>
                    <el-input v-model='createForm.excelEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票抬头'>
                    <el-input v-model='createForm.excelTitleInvoiceName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='抬头类型'>
                    <el-input v-model='createForm.excelTitleInvoiceType' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票税号'>
                    <el-input v-model='createForm.excelTaxId' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票金额'>
                    <el-input v-model='createForm.excelTaxAmount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票email'>
                    <el-input v-model='createForm.excelTaxEmail' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票备注'>
                    <el-input v-model='createForm.excelTaxRemark' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票地址'>
                    <el-input v-model='createForm.excelTaxAddress' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票电话'>
                    <el-input v-model='createForm.excelTaxPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行名称'>
                    <el-input v-model='createForm.excelTaxBank' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行账号'>
                    <el-input v-model='createForm.excelTaxBankAccount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='身份证正面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelFrontIdCardUrl"
                        :preview-src-list="[createForm.excelFrontIdCardUrl]">
                    </el-image>

                </el-form-item>
                <el-form-item label='身份证反面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelBackIdCardUrl"
                        :preview-src-list="[createForm.excelBackIdCardUrl]">
                    </el-image>

                </el-form-item>



                <el-form-item label='营业执照'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelYyzz"
                        :preview-src-list="createForm.bbrZlhtUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='付款凭证'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.fkpzUrl"
                        :preview-src-list="createForm.fkpzUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='开票照片'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.ticketPhoto"
                        :preview-src-list="[createForm.ticketPhoto]">
                    </el-image>

                </el-form-item>

                <el-form-item label='返现凭证'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.fanXianUrls'
                        ref='upload'

                        :http-request='uploadFileProcessUrls'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>


            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='cashbackVisible = false'>取 消</el-button>
                <el-button type='primary' @click='handleStatus(2)'>返 现</el-button>
            </span>
        </el-dialog>

        <el-dialog title='查看详情' :visible.sync='watchVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='保单号'>
                    <el-input v-model='createForm.tradeNo' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险名'>
                    <el-input v-model='createForm.baoXieName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price/100' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='企业名称'>
                    <el-input v-model='createForm.excelEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票抬头'>
                    <el-input v-model='createForm.excelTitleInvoiceName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='抬头类型'>
                    <el-input v-model='createForm.excelTitleInvoiceType' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票税号'>
                    <el-input v-model='createForm.excelTaxId' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票金额'>
                    <el-input v-model='createForm.excelTaxAmount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票email'>
                    <el-input v-model='createForm.excelTaxEmail' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票备注'>
                    <el-input v-model='createForm.excelTaxRemark' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票地址'>
                    <el-input v-model='createForm.excelTaxAddress' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票电话'>
                    <el-input v-model='createForm.excelTaxPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行名称'>
                    <el-input v-model='createForm.excelTaxBank' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='发票银行账号'>
                    <el-input v-model='createForm.excelTaxBankAccount' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='身份证正面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelFrontIdCardUrl"
                        :preview-src-list="[createForm.excelFrontIdCardUrl]">
                    </el-image>

                </el-form-item>
                <el-form-item label='身份证反面'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelBackIdCardUrl"
                        :preview-src-list="[createForm.excelBackIdCardUrl]">
                    </el-image>

                </el-form-item>



                <el-form-item label='营业执照'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.excelYyzz"
                        :preview-src-list="createForm.bbrZlhtUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='付款凭证'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.fkpzUrl"
                        :preview-src-list="createForm.fkpzUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='开票照片'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.ticketPhoto"
                        :preview-src-list="[createForm.ticketPhoto]">
                    </el-image>

                </el-form-item>

                <el-form-item label='返现凭证'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.fanXianUrl"
                        :preview-src-list="[createForm.fanXianUrl]">
                    </el-image>

                </el-form-item>

            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            SettledEnterpriseId: '',
            amountIsShow: '1',
            camountIsShow: '1',
            enterpriseId: '',
            isDiscount: '0',
            dateSelectValue: [],
            watchVisible: false,
            checkVisible:false,
            cashbackVisible:false,
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            addEnterpriseVisible: false,
            mealOptions: [],
            cardOptions: [],
            mealValue: '',
            enterpriseSearchId: '',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10,
                status: '',
                type:"",
                heHuoName:"",
                tbrName:"",
                bbrName:""
            },

            updateType: 'add',
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            photoUrl: ''
            ,
            createForm: {

                imageUrl: '',
                tbrTbdUrls:[]

            }
            ,
            SettledEnterprise: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            typeOptions: [{ 'value': '', 'label': '请选择支付方式' }, { 'value': '0', 'label': '线下支付' }, {
                'value': '1',
                'label': '线上支付'
            }],
            statusOptions: [{ 'value': '', 'label': '请选择订单状态' }, { 'value': '0', 'label': '未支付' }, {
                'value': '1',
                'label': '已完成'
            }, {
                'value': '2',
                'label': '待返现'
            }, {
                'value': '3',
                'label': '待审核'
            }, {
                'value': '10',
                'label': '已取消'
            }],
            enterpriseOptions: [],
            enterpriseValue: '',
            specialRecruitId: '',


        };
    },
    watch: {},
    created() {
        this.getData();
        this.getEnterpriseData();


    },


    methods: {
        handleRemove(file,fileList) {
            this.createForm.photoUrlList=[]
            for (const fileKey in fileList) {
                this.createForm.photoUrlList.push({"url":fileList[fileKey].url})

            }

        },
        uploadFileProcessUrls(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.fanXianUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.processUrl;
                    // that.createForm.photoUrlList = [];

                    that.createForm.fanXianUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        beforeAvatarUpload(file) {
            console.log('hello');
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uploadFileLogo(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.imageUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.imageUrl;
                    // that.createForm.photoUrlList = [];
                    that.createForm.photoUrlList.push({ url: picUrl });

                }
            }, err => {
                // 出现错误时的处理
            });
        },
        indexMethod(index) {
            return index + 1;
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        }
        ,
        getData() {
            let that = this;
            this.query.enterpriseId = this.enterpriseSearchId;
            this.http.getToken('/InsuranceProducts/getOrderList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        for (const resKey in res.data.records) {
                           let data =  res.data.records[resKey];
                           data.tbrTbdUrls = [data.tbrTbdUrl]
                            data.tbrYyzzUrls=[data.tbrYyzzUrl]
                            data.bbrYyzzUrls=[data.bbrYyzzUrl]
                            data.bbrZlhtUrls=[data.bbrZlhtUrl]
                            data.fkpzUrls = [data.fkpzUrl]
                        }

                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        getSettledEnterprise(id) {
            let that = this;
            that.SettledEnterpriseId = id;
            let param = {};
            param.specialRecruitId = id;
            this.http.get('SpecialRecruit/getSettledEnterprise', param).then(res => {
                    if (res.code == 0) {
                        that.SettledEnterprise = res.data;

                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.post('SpecialRecruit/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        delSettledEnterpriseById(id) {
            let that = this;
            this.http.post('SpecialRecruit/delSettledEnterpriseById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getSettledEnterprise(that.SettledEnterpriseId);
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },
        // 删除操作
        handleWatchDelete(index, row) {

            // 二次确认删除
            let that = this;
            console.log('handleWatchDelete' + row.id);

            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delSettledEnterpriseById(row.specialRecruitEnterpriseId);

                })
                .catch(() => {
                });
        },
        getEnterpriseData() {

            let that = this;
            console.log('getEnterpriseData' + this.query.pageSize);
            let params = {};
            params.pageSize = 99999;
            params.pageIndex = 1;
            params.status = 1;
            this.http.get('/qwpenterprise/getList', params).then(res => {
                    if (res.code == 0) {

                        that.enterpriseOptions = [];
                        for (const i in res.data.records) {
                            that.enterpriseOptions.push({
                                'value': res.data.records[i].id,
                                'label': res.data.records[i].name
                            });
                        }
                        console.log('enterpriseOptions');
                        // that.tableData = res.data.records;
                        // that.pageTotal = parseInt(res.data.total);

                    }
                },
                err => {

                });
        },
        addUser() {

            this.createForm = {};
            this.form = {};
            this.createForm.photoUrl = '';
            this.dateSelectValue = [];
            this.createForm.photoUrlList = [];

            this.addVisible = true;

        },

        addUserHttp() {
            this.updateType = 'add';
            let that = this

            that.http.postToken('/banner/add', that.createForm).then(res => {
                if (res.code === 0) {
                    that.createForm = {};
                    that.dateSelectValue = [];
                    that.getData();
                    that.addVisible = false;
                    that.$message.success('添加成功');
                }

            });

        }
        ,
        updateStatus(status) {
            let that = this;
            let params = {};
            params.status=status;
            params.tradeNo=this.createForm.tradeNo
            this.http.postToken('/InsuranceProducts/updateOrderStatus', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    this.createForm = {};
                    that.checkVisible = false;
                    that.$message.success('操作成功');
                }

            });
        }
        ,
        handleStatus(index){
            let that = this;
            let params = {};

          params = { 'id': this.createForm.id, 'status': 2,"fanXianUrl":this.createForm.fanXianUrl };


                    that.http.postToken('/InsuranceProducts/updateOrderFanXById', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            that.cashbackVisible = false;
                            this.$message.success('操作成功');
                        }
                    });


        },
        AddEnterpriseHttp() {
            let that = this;

            // this.$refs.uploadRef.submit()
            let params = {};
            params.enterpriseId = this.enterpriseValue;
            params.specialRecruitId = this.specialRecruitId;
            this.http.post('SpecialRecruit/addEnterprise', params).then(res => {
                if (res.code == 0) {
                    that.getSettledEnterprise(this.SettledEnterpriseId);
                    that.getData();

                    that.$message.success('添加成功');
                }

            });
        }
        ,
        // 编辑操作
        checkOrder(index, row) {
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.checkVisible = true;
        },
        excelTax(index,row){
            let paramsData={"id":row.id}
            // let url = "https://localhost:8888/InsuranceProducts/exportById?id="+row.id;//路径地址
            // window.location.href = url
            // let link = document.createElement('a');
            // fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
            //     link.href = URL.createObjectURL(blob);
            //     link.download = res.data.content.filename;
            //     document.body.appendChild(link);
            //     link.click()
            // })
            let that = this
            this.http.get('/InsuranceProducts/exportById', paramsData).then(res => {
                    if (res.code == 0) {
                        let url =  that.http.getDownLoadUrl()+res.data[0]
                        that.downLoadByUrl(url,res.fileName )
                        // that.tableData = res.data.records;
                        // for (const resKey in res.data.records) {
                        //     let data =  res.data.records[resKey];
                        //     data.tbrTbdUrls = [data.tbrTbdUrl]
                        //     data.tbrYyzzUrls=[data.tbrYyzzUrl]
                        //     data.bbrYyzzUrls=[data.bbrYyzzUrl]
                        //     data.bbrZlhtUrls=[data.bbrZlhtUrl]
                        //     data.fkpzUrls = [data.fkpzUrl]
                        // }
                        //
                        // that.pageTotal = parseInt(res.data.total);
                        // this.$message.success('获取数据成功');

                    }
                },
                err => {

                });

        },
        downLoadByUrl(url,fileName)
        {
            var xhr = new XMLHttpRequest();
            //GET请求,请求路径url,async(是否异步)
            xhr.open('GET', url, true);
            //设置请求头参数的方式,如果没有可忽略此行代码
            // xhr.setRequestHeader("token", token);
            //设置响应类型为 blob
            xhr.responseType = 'blob';
            //关键部分
            xhr.onload = function(e) {
                //如果请求执行成功
                if (this.status == 200) {
                    var blob = this.response;
                    var filename = fileName;//如123.xls
                    var a = document.createElement('a');
                    //创键临时url对象
                    var url = URL.createObjectURL(blob);

                    a.href = url;
                    a.download = filename;
                    a.click();
                    //释放之前创建的URL对象
                    window.URL.revokeObjectURL(url);
                }
            };
            //发送请求
            xhr.send();
        },
        fanXian(index, row){
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.fanXianUrls=[]
            this.cashbackVisible = true;
        },
        watchOrder(index, row) {
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.watchVisible = true;
        },
        watchPdf(index, row){
            this.idx = index;
            if (row.excelRzzlhtPdfUrl==null || row.excelRzzlhtPdfUrl==''){
                this.$message.error('pdf未上传');
            }else {
                window.open(row.excelRzzlhtPdfUrl);
            }


        },
        handleWatch(index, row) {
            this.specialRecruitId = row.id;
            // this.idx = index;
            // this.createForm = {};
            // this.createForm.name = row.name;
            // this.createForm.id = row.id;
            // this.createForm.photoUrl = row.photoUrl;
            // this.createForm.photoUrlList=[]
            // this.dateSelectValue[0]= new Date(row.startTime)
            // this.dateSelectValue[1]= new Date(row.endTime)
            // this. createForm.photoUrlList.push({pic:row.photoUrl})
            this.getSettledEnterprise(row.id);
            this.watchVisible = true;
        },
        handlePreview(file) {
            console.log('handlePreview');

        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
